import { CartesianGrid, Line, LineChart, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { CircularProgress } from '@mui/material';

import { EmailReportSeriesBucketOutDto } from '@app/swagger-types';

// admin-emailbeheer blok B (opdracht §4, "Grafiek 2 en 3"): always its own chart, never bounce
// and complaint on one plot with two axes - the opdracht is explicit that the scales
// (1-3% vs 0.05-0.25%) would suggest a correlation that isn't there.
export const EmailReportPercentChart: React.FC<{
  buckets: EmailReportSeriesBucketOutDto[];
  loading?: boolean;
  dataKey: 'bouncePercent' | 'complaintPercent';
  hardLimit: number;
}> = ({ buckets, loading, dataKey, hardLimit }) => {
  if (loading) {
    return (
      <div className="flex h-[220px] items-center justify-center">
        <CircularProgress />
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={220}>
      <LineChart data={buckets} margin={{ top: 16 }}>
        <CartesianGrid stroke="#E5E7EB" vertical={false} />
        <XAxis dataKey="label" tickLine={false} axisLine={false} />
        <YAxis tickLine={false} axisLine={false} tickFormatter={(v) => `${v}%`} />
        <Tooltip cursor={false} wrapperClassName="rounded" formatter={(value: number) => `${value.toFixed(2)}%`} />
        <ReferenceLine y={hardLimit} stroke="#F87171" strokeDasharray="4 4" />
        <Line type="monotone" dataKey={dataKey} stroke="#2C9424" strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  );
};
